import type { SVGProps } from 'react';

/** Figma `mic-lesson.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MicLessonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 23.5 27.5291"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 167">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00714 9.40234C1.56337 9.40234 2.01429 9.85321 2.01429 10.4094V11.7521C2.01429 17.1284 6.37311 21.4868 11.75 21.4868C17.1269 21.4868 21.4857 17.1284 21.4857 11.7521V10.4094C21.4857 9.85321 21.9366 9.40234 22.4929 9.40234C23.0491 9.40234 23.5 9.85321 23.5 10.4094V11.7521C23.5 17.9016 18.775 22.9475 12.7571 23.4583V26.522C12.7571 27.0782 12.3062 27.5291 11.75 27.5291C11.1938 27.5291 10.7429 27.0782 10.7429 26.522V23.4583C4.72498 22.9475 0 17.9016 0 11.7521V10.4094C0 9.85321 0.450913 9.40234 1.00714 9.40234Z"
        fill="#AF52DE"
      />
      <path
        id="Vector_2"
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7523 0C7.4879 0 4.0309 3.45665 4.0309 7.72064V11.7488C4.0309 16.0128 7.4879 19.4694 11.7523 19.4694C16.0168 19.4694 19.4738 16.0128 19.4738 11.7488V7.72064C19.4738 3.45665 16.0168 0 11.7523 0ZM14.438 12.7558C14.9943 12.7558 15.4452 12.305 15.4452 11.7488C15.4452 11.1926 14.9943 10.7418 14.438 10.7418H9.06662C8.51039 10.7418 8.05947 11.1926 8.05947 11.7488C8.05947 12.305 8.51039 12.7558 9.06662 12.7558H14.438ZM14.1023 7.72064C14.1023 8.27681 13.6514 8.72768 13.0952 8.72768H10.4095C9.85324 8.72768 9.40233 8.27681 9.40233 7.72064C9.40233 7.16446 9.85324 6.7136 10.4095 6.7136H13.0952C13.6514 6.7136 14.1023 7.16446 14.1023 7.72064Z"
        fill="#AF52DE"
      />
      <g id="Vector_3">
        <path
          d="M14.4353 12.7532C14.9915 12.7532 15.4424 12.3023 15.4424 11.7461C15.4424 11.19 14.9915 10.7391 14.4353 10.7391H9.06384C8.50761 10.7391 8.0567 11.19 8.0567 11.7461C8.0567 12.3023 8.50761 12.7532 9.06384 12.7532H14.4353Z"
          fill="#AF52DE"
        />
        <path
          d="M13.0924 8.72502C13.6486 8.72502 14.0996 8.27415 14.0996 7.71798C14.0996 7.1618 13.6486 6.71094 13.0924 6.71094H10.4067C9.85047 6.71094 9.39956 7.1618 9.39956 7.71798C9.39956 8.27415 9.85047 8.72502 10.4067 8.72502H13.0924Z"
          fill="#AF52DE"
        />
      </g>
    </g>
  </svg>
);
